module.exports = __webpack_public_path__ + "img/2025-09-19c_1.e593aa46.jpg";